import React from 'react';
import { Form } from 'antd';
import PropTypes from 'prop-types';

import OnTraccrNumberInput from '../../../common/inputs/OnTraccrNumberInput';
import DisplayText from '../../../common/text/DisplayText';

export default function ProjectNumberInput({
  title,
  name,
  isNotDisplay,
  onChange,
  value,
  labelStyle = {},
  displayStyle = {},
  min,
  max,
  step,
  precision,
  displayFormatter,
}) {
  const formattedValue = displayFormatter ? displayFormatter(value) : String(value);
  const displayValue = value === null ? 'N/A' : formattedValue;

  return (
    <Form.Item
      name={name}
      label={title}
      style={{ marginBottom: 0, ...labelStyle }}
    >
      {isNotDisplay ? (
        <OnTraccrNumberInput
          min={min}
          max={max}
          step={step}
          precision={precision}
          style={{ width: '100%' }}
          onChange={onChange}
          className="budget-tracking-display-dropdown"
        />
      ) : (
        <DisplayText title={displayValue} style={displayStyle} displayAsDropdown />
      )}
    </Form.Item>
  );
}

/* eslint-disable react/forbid-prop-types */
ProjectNumberInput.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isNotDisplay: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.number,
  labelStyle: PropTypes.object,
  displayStyle: PropTypes.object,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  precision: PropTypes.number,
  displayFormatter: PropTypes.func,
};

ProjectNumberInput.defaultProps = {
  isNotDisplay: false,
  onChange: null,
  value: null,
  labelStyle: {},
  displayStyle: {},
  min: undefined,
  max: undefined,
  step: undefined,
  precision: undefined,
  displayFormatter: null,
};
